/**
 * LayoutSidebarScrollAreas Component
 * includes fixed sidebar and scrollable main area with footer
 * rerenders when route params change
 */
import { useContext } from "react";
import Footer from "./Footer";
import { SidebarOpenContext } from "./LayoutHeaderArea";

export default function LayoutSidebarScrollAreas({
  sidebar,
  children,
}: {
  sidebar?: React.ReactNode;
  children: React.ReactNode;
}) {
  const isSidebarOpen = useContext(SidebarOpenContext);
  const sidebarClasses = isSidebarOpen
    ? "overflow-auto border-end bg-light"
    : "overflow-auto border-end bg-light d-none";

  return (
    <>
      {/* Sidebar: left column, under the header */}
      <div
          className={`${sidebarClasses} sidebar-scroll`}
        aria-hidden={!isSidebarOpen}
        style={{
          gridColumn: "1 / 2",
          gridRow: "2 / 3",
          background: "linear-gradient(180deg, #334155 0%, #1E293B 100%)",
        }}
      >
        {sidebar}
      </div>

      {/* Scroll Area: right column, second row under the header */}
      <div
        className="overflow-auto d-flex flex-column"
        style={{ gridColumn: "2 / 3", gridRow: "2 / 3" }}
      >
        <main
          className="flex-grow-1 flex-shrink-0"
          style={{ backgroundColor: "var(--background)" }}
        >
          {/* Focus target for the skip link: scoped to the content itself (not
              the flex-grow-1 <main>) so the focus outline hugs the content
              instead of the full stretched-to-bottom container. */}
          <div id="content" tabIndex={-1} className="main-content-area">
            {children}
          </div>
        </main>

        <div>
          <Footer />
        </div>
      </div>
    </>
  );
}
